import produce from 'immer';
import { DetailsMenu } from '../details.data';

export type TPostType = {
    post: keyof DetailsMenu;
    placeHolder: string[];
};

export type TPublishStatus =
    | 'Scheduled Publish - Publish at a specified date'
    | 'Draft - Publish at a later date.'
    | 'Publish Immediately - Immediately available to anyone on thspian';
export type TPublisher = 'draft' | 'publish' | 'schedule';

// Define the IPostFormInitialState type
export type IPostFormInitialState = {
    [key in keyof DetailsMenu]?: Record<string, any>;
} & {
    category: keyof DetailsMenu; // Ensure this is a valid key of DetailsMenu
    postType: TPostType;
    status: TPublishStatus;
    publishStatus?: TPublisher;
    title: string;
    selectedColor: string | null;
    images?: any[];
    videos?: any[];
    audios?: any[];
    files?: any[];
    scheduled_published_date?: string;
    rawFiles?: File[];
};

export const initialState: IPostFormInitialState = {
    category: 'thought',
    postType: {
        post: 'thought',
        placeHolder: [
            'Ask a question or share a thougth',
            'e.g How does one get into acting?',
            'Our company is hiring actors...',
            'Just made a portfolio...looking for more gigs',
        ],
    },
    status: 'Publish Immediately - Immediately available to anyone on thspian',
    publishStatus: 'publish',
    title: '',
    selectedColor: null,
    images: [],
};

const actions = {
    FIELD: 'FIELD',
    RESET: 'RESET',
    OVERRIDE: 'OVERRIDE',
};

export function reducer(state = initialState, action: any) {
    switch (action.type) {
        case actions.FIELD:
            return produce(state, (draftState: { [x: string]: any }) => {
                draftState[action.field] = action.value;
            });
        case actions.OVERRIDE:
            return produce(state, () => {
                return action.value;
            });
        case actions.RESET:
            return produce(state, () => {
                return initialState;
            });
        default:
            return state;
    }
}
